import './index.css';
import { createRoot } from 'react-dom/client';
import { isMockMode } from './mocks/mockMode';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

const renderApp = async () => {
  if (isMockMode()) {
    const { startMockMode } = await import('./mocks/startMockMode');
    startMockMode();
  }
  const { default: App } = await import('./App');
  root.render(<App />);
};

renderApp().catch((error) => {
  console.error('Failed to start the application', error);
});
